// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfa-settings-page p {
    padding: 0 0 8px 0;
}

.mfa-section {
    margin-top: 1em;
}

.mfa-section .field-group {
    margin-top: 0.75em;
}

.mfa-section.mfa-passkeys {
    margin-top: 0;
}

.mfa-sub-header {
    font-size: larger;
    font-weight: bold;
    margin-bottom: 5px;
}

.mfa-passkey-add button,
.mfa-totp button,
.mfa-recovery-codes button {
    width: 100% !important;
}

.mfa-passkey {
    position: relative;
    overflow: hidden;
    margin-bottom: 5px;
    padding: 6px 4px 6px 14px;
    border: var(--border);
    border-radius: var(--border_radius);
}

.passkey-header {
    position: relative;
    display: flex;
    align-items: center;
    gap: 2px;
}

.passkey-details p {
    margin: 0;
    padding: 0;
}

.passkey-icon,
.passkey-status {
    font-size: var(--text_sm);
    color: var(--lightest_legible_grey);
}

.passkey-name-container {
    display: flex;
    align-items: center;
    flex-grow: 1;
}

.passkey-icon {
    margin-right: 10px;
}

.passkey-name {
    max-width: 15em;
    overflow: hidden;
}

.mfa-section .save-button {
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/Mfa.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb","sourcesContent":[".mfa-settings-page p {\n    padding: 0 0 8px 0;\n}\n\n.mfa-section {\n    margin-top: 1em;\n}\n\n.mfa-section .field-group {\n    margin-top: 0.75em;\n}\n\n.mfa-section.mfa-passkeys {\n    margin-top: 0;\n}\n\n.mfa-sub-header {\n    font-size: larger;\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n.mfa-passkey-add button,\n.mfa-totp button,\n.mfa-recovery-codes button {\n    width: 100% !important;\n}\n\n.mfa-passkey {\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 5px;\n    padding: 6px 4px 6px 14px;\n    border: var(--border);\n    border-radius: var(--border_radius);\n}\n\n.passkey-header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.passkey-details p {\n    margin: 0;\n    padding: 0;\n}\n\n.passkey-icon,\n.passkey-status {\n    font-size: var(--text_sm);\n    color: var(--lightest_legible_grey);\n}\n\n.passkey-name-container {\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n}\n\n.passkey-icon {\n    margin-right: 10px;\n}\n\n.passkey-name {\n    max-width: 15em;\n    overflow: hidden;\n}\n\n.mfa-section .save-button {\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
